import * as React from "react"

import CursosFormato from '../icons/CursosFormato'
import CursosPerfil from '../icons/CursosPerfil'
import CursosNivel from '../icons/CursosNivel'
import CursosAulas from '../icons/CursosAulas'
import CursosModulos from '../icons/CursosModulos'
import CursosHorasConteudo from '../icons/CursosHorasConteudo'
import CursosOnline from '../icons/CursosOnline'
import CursosEncontros from '../icons/CursosEncontros'

import WorkshopBenchmark from '../icons/WorkshopBenchmark'
import WorkshopDinamica from '../icons/WorkshopDinamica'
import WorkshopEquipeSenior from '../icons/WorkshopEquipeSenior'
import WorkshopMetodologia from '../icons/WorkshopMetodologia'

import CasesResultadosCheck from '../icons/CasesResultadosCheck'

import ConsultoriaDiagnotisco from '../icons/ConsultoriaDiagnostico'
import ConsultoriaGestao from '../icons/ConsultoriaGestao'
import ConsultoriaMapeamento from '../icons/ConsultoriaMapeamento'

import NaMidiaTv from '../icons/NaMidiaTv'
import NaMidiaArtigo from '../icons/NaMidiaArtigo'
import NaMidiaLink from '../icons/NaMidiaLink'
import NaMidiaAudio from '../icons/NaMidiaAudio'

const IconsAvailable = {  
  formato : CursosFormato,
  perfil : CursosPerfil,
  nivel : CursosNivel,
  aulas : CursosAulas,
  modulos : CursosModulos,
  conteudo : CursosHorasConteudo,
  online : CursosOnline,
  encontros : CursosEncontros,
  equipe : WorkshopEquipeSenior,
  benchmark : WorkshopBenchmark,
  dinamicas : WorkshopDinamica,
  metodologia : WorkshopMetodologia,
  check: CasesResultadosCheck,
  consultoriaDiagnotisco : ConsultoriaDiagnotisco,
  consultoriaRiscos : ConsultoriaGestao,
  consultoriaMapeamento : ConsultoriaMapeamento,
  tv: NaMidiaTv,
  artigo: NaMidiaArtigo,
  link: NaMidiaLink,
  audio: NaMidiaAudio
}

export default function Icon({ 
    type, 
    title,
    content,
    wrapperClass = "d-flex flex-column justify-content-center align-items-center py-4 tac",
    ...others
  }) {

  const RenderedIcon = IconsAvailable[type]
  return (
    <div className={wrapperClass}>
      
      { Object.keys(IconsAvailable).includes(type) ? <RenderedIcon  /> : type }

      { title &&
        <strong className="c-purple-2">{title} </strong>
      }

      { content &&
        <span className="mt-2 dib col-size-320 m-auto">{content}</span>
      }

    </div>
  ) 
}
